import React from "react";
import Layout from "@/components/layout";
import HeaderTwo from "@/components/header-two";

import MenuContextProvider from "@/context/menu-context";
import PageHeader from "@/components/page-header";
import Footer from "@/components/footer";
import BlogTwo from "@/components/blog-two";

const Blog = () => {
  return (
    <MenuContextProvider>
      <Layout PageTitle="Blog Page">
        <HeaderTwo />
        <PageHeader title="Blog Grid" name="Blog" />
        <BlogTwo />
        <Footer />
      </Layout>
    </MenuContextProvider>
  );
};

export default Blog;
